export default __webpack_public_path__ + "72c67be4ba4a9e040094ef9cb6f6123a.png";